import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Session } from '../api/types';
import { InfoIcon } from './ui/icons';
import { useTabItems } from './BottomTabBar';
import './AppBar.css';

interface AppBarProps {
  session: Session | null;
}

const AppBar: React.FC<AppBarProps> = ({ session }) => {
  const [clickCount, setClickCount] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const items = useTabItems(session);
  const { pathname } = useLocation();

  const handleTitleClick = () => {
    const newCount = clickCount + 1;
    setClickCount(newCount);

    // Reset count after 3 seconds of no clicks
    setTimeout(() => {
      setClickCount(0);
    }, 3000);

    // Trigger Easter egg after 5 clicks
    if (newCount >= 5 && !isPlaying) {
      playJerusalem();
    }
  };

  const playJerusalem = () => {
    if (isPlaying) return;

    setIsPlaying(true);

    // Open the YouTube link to the actual Jerusalem performance
    window.open('https://www.youtube.com/watch?v=GNGH6E7-pFQ', '_blank');

    // Reset playing state after a short delay
    setTimeout(() => {
      setIsPlaying(false);
      setClickCount(0);
    }, 2000);
  };

  return (
    <header className="app-bar">
      <Link to="/" className="app-bar-wordmark" onClick={handleTitleClick}>
        Scan · Drink · Race
      </Link>

      {/* Desktop-only horizontal nav; hidden below 768px in AppBar.css */}
      <nav className="app-bar-nav" aria-label="Main">
        {items.map(item => {
          const active = item.isActive(pathname);
          return (
            <NavLink
              key={item.id}
              to={item.to}
              className={`app-bar-nav-item ${active ? 'app-bar-nav-item-active' : ''}`}
              aria-current={active ? 'page' : undefined}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      <Link to="/faqs" className="app-bar-info" aria-label="FAQs">
        <InfoIcon />
      </Link>
    </header>
  );
};

export default AppBar;
